<template>
  <md-field
    :class="fieldClass"
    :inline="inline"
    :clearable="clearable"
    :togglePassword="togglePassword"
  >
    <label v-if="label" :for="id">{{ label }}</label>
    <span v-if="clear && value"
          class="md-select-clear-selection"
          @click="clearSelection">
      <md-icon class="clear-icon-size">clear</md-icon>
    </span>
    <md-input
      :id="id"
      :type="type"
      :ref="name"
      :name="name"
      :value="value"
      :counter="counter"
      :required="required"
      :disabled="disabled"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :readonly="readonly"
      :class="'text-align-' + align"
      :step="step"
      :aria-autocomplete="autocomplete ? 'on' : 'off'"
      :autocomplete="autocomplete ? 'on' : 'off'"
      @input="onInput"
      @blur="onBlur"
      @focus="onFocus"
      v-on:keyup.enter="onEnterKeypress"
    />
    <span class="md-error" v-if="errorMessage">{{ errorMessage }}</span>
  </md-field>
</template>

<script>
  import FieldMixin from './field.mixin'

  export default {
    name: 'input-field',
    mixins: [FieldMixin],
    props: {
      type: { type: String, default: 'text' },
      maxlength: { type: [Number, null], default: null },
      counter: { type: [Number, null], default: null },
      readonly: { type: Boolean, default: false },
      align: { type: String, default: 'left' },
      step: { type: Number, default: 0.000001 },
      disabled: { type: Boolean, default: false },
      id: { type: String, default: '' },
      autocomplete: { type: Boolean, default: true },
      autofocus: {type: Boolean, default: false},
      inline: {type: Boolean, default: false},
      clear: {type: Boolean, default: false}
      // TODO: need handle number properties:
      // min: { type: Number, default: 0 },
    },
    mounted () {
      if (this.autofocus) {
        setTimeout(() => this.$refs[this.name].$el.focus(), 100)
      }
    },
    methods: {
      clearSelection () {
        this.$emit('input', '')
      }
    }
  }
</script>

<style lang="scss" scoped>
.md-select-clear-selection {
  position: absolute;
    right: 10px;
    top: 5px;
}
</style>


// WEBPACK FOOTER //
// src/vue/common/fields/InputField.vue